

<script setup lang="ts">

// Props 接口定义
interface Props {
  total: number
  page?: number
  limit?: number
  pageSizes?: number[]
  pagerCount?: number
  layout?: string
  background?: boolean
  autoScroll?: boolean
  hidden?: boolean
}

// Emits 事件类型定义
interface PaginationPayload {
  page: number
  limit: number
}

const props = withDefaults(defineProps<Props>(), {
  page: 1,
  limit: 20,
  pageSizes: () => [10, 20, 30, 50],
  // 移动端页码按钮的数量端默认值5
  pagerCount: 7,
  layout: 'total, sizes, prev, pager, next, jumper',
  background: true,
  autoScroll: true,
  hidden: false
})

const emit = defineEmits<{
  'update:page': [value: number]
  'update:limit': [value: number]
  'pagination': [payload: PaginationPayload]
}>()

const currentPage = computed({
  get(): number {
    return props.page
  },
  set(val: number): void {
    emit('update:page', val)
  }
})

const pageSize = computed({
  get(): number {
    return props.limit
  },
  set(val: number): void {
    emit('update:limit', val)
  }
})


function handleSizeChange(val: number): void {
  if (currentPage.value * val > props.total) {
    currentPage.value = 1
  }
  emit('pagination', { page: currentPage.value, limit: val })
}

function handleCurrentChange(val: number): void {
  emit('pagination', { page: val, limit: pageSize.value })
}
</script>

<template>
  <div :class="{ 'hidden': hidden }" class="pagination-container">
    <el-pagination
      :background="background"
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: flex-end;
  background: #fff;
  padding: 16px;
}
.pagination-container.hidden {
  display: none;
}
</style>
